import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppService } from 'app/app.service';
import { MetricsService } from './metrics.service';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ConsoleMetricsService implements MetricsService {

    private router = inject(Router);
    private appService = inject(AppService);

    private uuidPattern: RegExp = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'g');

    constructor() {
        this.capturePageViews(this.router);
    }

    private capturePageViews(router: Router) {
        router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.capture('page_view', this.currentLocation(event.urlAfterRedirects));
        });
    }

    capture(eventName: string, payload: any): void {
        console.group(eventName);
        console.log({
            ...payload,
            user_id: this.appService?.user?.id,
            user_client_id: this.appService?.client?.id,
            ...this.currentLocation(window.location.href)
        });
        console.groupEnd();
    }

    exception(payload: unknown): void {
        console.error(payload);
    }

    reset(): void {
        throw new Error('Method not implemented.');
    }

    private currentLocation(url: string): { page_location: string, sanitised_url: string,  host_name: string} {
        const sanitisedUrl = url.replace(this.uuidPattern, '-');
        return {
            page_location: url,
            sanitised_url: sanitisedUrl,
            host_name: window.location.origin
        }
    }
}
